// 日语
const jp = {

    html: {
        title: "『AFK アリーナ』期間限定報酬：チャージすると限定アイコンフレームをプレゼント",
        description: "『AFK アリーナ』・Lilith Store専属報酬が登場！Lilith Storeで『AFK アリーナ』にチャージすると、限定アイコンフレーム「金箔の羽付き冠」（無期限）が無料で手に入ります。期間限定でもらえるプレゼントなので、お見逃しなく！",
        Keywords: "AFK アリーナ、AFK アリーナ iOS、AFK アリーナ Android、AFK アリーナ 公式サイト、Lilith Games、AFK アリーナ、AFK アリーナチャージ、Lilith、Lilith Games、Lilith Store、PlutoMall"
    },

    rule: {
        title: "イベントについて",
        detial: `
            <p>1. イベント期間：2024/9/1 09:00より期間限定で開催。</p>
            <p>2. 参加方法：2024年9月1日より、Lilith Storeでチャージを行うと、専属報酬アイテムがもらえます。</p>
            <p>3. 報酬の配布：この画面で報酬を受け取ると、報酬はゲーム内のメールで送られます。ご確認ください。</p>
            <p>4. 報酬内容：『AFK アリーナ』限定アイコンフレーム「金箔の羽付き冠」（無期限）。</p>
            <p>5. 注意事項：</p>
            <p>（1）アイテム受領後に返金処理を行った場合、プレゼントアイテムを回収する場合があります。</p>
            <p>（2）ネットワークの遅延により、チャージデータが遅れて表示される場合があります。チャージ完了後、チャージデータが表示されなかった場合は、手動でページを更新してください。また、主催者以外の理由により、イベントへの参加、報酬の交換、報酬の受取を正常に行われず、その結果、報酬が発行されなかった場合は、イベントへの参加を放棄、または報酬を放棄したものとみなし、すべての損失はご自身が責任を負うものとし、主催者はいかなる補償も行いませんので、ご了承ください。</p>
            <p>（3）イベント期間中、プレイヤーが規則に違反した場合（不正な手段で報酬を受け取る、悪意ある第三者を利用するなどを含むが、これらに限定されない）、主催者は当該プレイヤーの本イベントへの参加資格を取消し、規則に違反して得た利益を回収し、法的責任を追及する権利を有します。</p>
            <p>（4）イベントに参加するために記入した、または主催者が収集したアカウントニックネーム、アカウントUID、連絡先（電話番号などを含むがこれに限定されない）及び他の個人情報はイベントへの参加を実現するために自発的に提供したものであり、主に本人確認、未成年者のチャージ制限、報酬の発行、個人納税（主催者またはその委託を受けた第三者は、法律に従って関連する源泉徴収および納税義務を履行する）のために使用されます。提供を拒否する権利を有しますが、拒否すると本イベントに参加できなくなる場合があります。個人情報の照会、変更、削除、承認撤回、または個人情報の保護に関するご質問やクレームがございましたら、お気軽にお問い合わせください。できるだけ迅速に対応いたします。主催者は、個人のプライバシーに関するすべての情報を秘密にすることを約束しますが、本イベントの広報・宣伝およびマーケティング活動の目的で、プレイヤーのオンラインプラットフォームのニックネーム、電話番号（番号の一部をマスキングする）、アイコンなどの個人情報を、公式ウェブサイトでの受賞者リストの公表、メディアへの受賞者情報の開示などを含むがこれらに限らない行為に使用することができるものとします。</p>
            <p>（5）インターネットには不確定要素が多いことを理解・同意し、不可抗力、ネットワークや通信回線の故障、大規模なコンピュータの麻痺、及びイベント期間中の大規模な不正行為など主催者以外の理由により、イベントに異常が生じたり、イベントの継続が困難になった場合、主催者は様々な方法で異常の解消やイベントの調整、中断、中止などの措置を講じる権利を有することを理解・同意するものとし、主催者は当該措置により生じた損害について責任を負わないものとします。</p>
            <p>（6）主催者は、法令上許容される範囲において、本イベントの説明及び他のルールを変更または調整する権利を有し、その内容はイベントページまたは主催者の公式ソーシャルアカウントで公開され、公開後直ちに効力を発揮します。変更されたイベント説明及び他のルールに異議がある場合は、直ちにイベントへの参加を中止してください。イベントへの参加を継続した場合、本イベント説明及び他のルールの変更に同意したものとみなされます。</p>
            <p>（7）本イベントはLilith Gamesが主催するものであり、Apple社とは一切関係ありません。ご質問がございましたら、afkarena-service@lilithgames.comまでお問い合わせください。</p>
        `,
    },

    login: {
        login: "タップしてログイン",
        logout: "ログアウト",
        changeRole: "キャラクター切替",
    },

    role: {
        title: "ログインキャラクターを選択",
        label1: "キャラクターのニックネーム",
        label2: "サーバー",
    },

    header: {
        timeTxt: "9月1日09:00より、Lilith Storeで『AFK アリーナ』のチャージを行うと、限定アイコンフレームがもらえます。",
        txt: "限定アイコンフレーム：金箔の羽付き冠",
        toPay: "チャージする",
        toSubmit: "今すぐ受け取る",
        submitEnd: "受取済み"
    },

    sys: {
        200: "限定アイコンフレームを受け取りました。ゲーム内メールをご確認ください。",
        405: "システム処理中です。しばらく待ってからもう一度試すか、カスタマーサポートにご連絡ください。"
    },

    btnOk: "確認",

    toast:'キャラクター情報を取得できません',
    awaitTxt:'支払い完了から、10分後にページ更新で獲得できます'

}
// 导出
export default jp;
